<div class="tab-pane" role="tabpanel" id="solicitante">
    <fieldset id="agregar_solicitante" class="">
        <div class="step_section">
            <h4 class="form-signin-heading"><strong>Informaci&oacute;n de los solicitantes(<span
                        style="color:red; font-size: 25px">*</span>)</strong></h4>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar solicitante</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_sol" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">
                                <form [formGroup]="rut_sol">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_sol" name="rut_sol"
                                            formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_sol && rut_sol.controls?.rut.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                        <mat-error *ngIf="rut_sol && rut_sol.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </form>

                                <!-- <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" #rut_solText="ngModel" [(ngModel)]="rut_sol" (ngModelChange)="validateRut($event)" id="rut_sol" name="rut_sol" >
                                        
                                    </mat-form-field> -->
                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_sol"
                                    [disabled]="!rut_sol.valid" (click)="get_solicitante(rut_sol.controls.rut.value)">
                                    Agregar solicitante
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--Detalle de los solicitantes-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span>
                                        {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_solicitante(row.rut, 'soloVer')" style="padding-right: 5px;"><i
                                            class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_solicitante(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>

    <!--Material Modal Dialog-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del solicitante</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del solicitante</strong>, su solicitud pasar&aacute; por un
                    proceso de verificaci&oacute;n del solicitante ingresado.
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md"
                            [(ngModel)]="solicitante.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_propiet">Nombre</label>
                    <div class="col-md-6">
                        <input id="nombre_propiet" name="nombre_propiet" type="text"
                            placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="solicitante.nombre"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div id="hide-prop-enterprise"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelpat_propiet">Apellido Paterno</label>
                    <div class="col-md-6">
                        <input id="apelpat_propiet" name="apelpat_propiet" type="text" placeholder="Apellido Paterno"
                            [(ngModel)]="solicitante.apellido_pat" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelmat_propiet">Apellido Materno</label>
                    <div class="col-md-6">
                        <input id="apelmat_propiet" name="apelmat_propiet" type="text" placeholder="Apellido Materno"
                            [(ngModel)]="solicitante.apellido_mat" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <!-- <div hidden="hidden"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_calle_propiet">Direcci&oacute;n Calle</label>
                    <div class="col-md-6">
                        <input id="direccion" name="direccion" type="text" placeholder="Calle"
                            [(ngModel)]="solicitante.direccion" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_num_propiet">Direcci&oacute;n Numero</label>
                    <div class="col-md-6">
                        <input id="dir_num_propiet" name="dir_num_propiet" type="text" placeholder="Numero"
                            [(ngModel)]="solicitante.direccion_num" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="direccion_complemento">Direcci&oacute;n
                        Complemento</label>
                    <div class="col-md-6">
                        <input id="direccion_complemento" name="direccion_complemento" type="text"
                            placeholder="Complemento" [(ngModel)]="solicitante.direccion_complemento"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="comuna">Comuna</label>
                    <div class="col-md-6">
                        <input id="comuna" name="comuna" type="text" placeholder="Comuna"
                            [(ngModel)]="solicitante.comuna" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_completa_propiet">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="dir_completa_propiet" name="dir_completa_propiet" type="text" placeholder="Completa"
                            [(ngModel)]="solicitante.direccion_completa" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_propiet">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                            [(ngModel)]="solicitante.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fax">Fax</label>
                    <div class="col-md-6">
                        <input id="fax" name="fax" type="text" placeholder="Fax" [(ngModel)]="solicitante.fax"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_propiet">Email</label>
                    <div class="col-md-6">
                        <input id="email_propiet" name="email_propiet" type="email" placeholder="mail@ejemplo.com"
                            [(ngModel)]="solicitante.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_propiet" (click)="saveSolicitante() ">Ingresar
                solicitante <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
    <!--Material Modal Dialog 2-->
    <ng-template #openModalVer>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del solicitante</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del solicitante</strong>, su solicitud pasar&aacute; por un
                    proceso de verificaci&oacute;n del solicitante ingresado.
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md"
                            [(ngModel)]="solicitante.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_propiet">Nombre</label>
                    <div class="col-md-6">
                        <input id="nombre_propiet" name="nombre_propiet" type="text"
                            placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="solicitante.nombre"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div id="hide-prop-enterprise"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelpat_propiet">Apellido Paterno</label>
                    <div class="col-md-6">
                        <input id="apelpat_propiet" name="apelpat_propiet" type="text" placeholder="Apellido Paterno"
                            [(ngModel)]="solicitante.apellido_pat" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelmat_propiet">Apellido Materno</label>
                    <div class="col-md-6">
                        <input id="apelmat_propiet" name="apelmat_propiet" type="text" placeholder="Apellido Materno"
                            [(ngModel)]="solicitante.apellido_mat" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <!-- <div hidden="hidden"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_calle_propiet">Direcci&oacute;n Calle</label>
                    <div class="col-md-6">
                        <input id="direccion" name="direccion" type="text" placeholder="Calle"
                            [(ngModel)]="solicitante.direccion" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_num_propiet">Direcci&oacute;n Numero</label>
                    <div class="col-md-6">
                        <input id="dir_num_propiet" name="dir_num_propiet" type="text" placeholder="Numero"
                            [(ngModel)]="solicitante.direccion_num" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="direccion_complemento">Direcci&oacute;n
                        Complemento</label>
                    <div class="col-md-6">
                        <input id="direccion_complemento" name="direccion_complemento" type="text"
                            placeholder="Complemento" [(ngModel)]="solicitante.direccion_complemento"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="comuna">Comuna</label>
                    <div class="col-md-6">
                        <input id="comuna" name="comuna" type="text" placeholder="Comuna"
                            [(ngModel)]="solicitante.comuna" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_completa_propiet">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="dir_completa_propiet" name="dir_completa_propiet" type="text" placeholder="Completa"
                            [(ngModel)]="solicitante.direccion_completa" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_propiet">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                            [(ngModel)]="solicitante.fono" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fax">Fax</label>
                    <div class="col-md-6">
                        <input id="fax" name="fax" type="text" placeholder="Fax" [(ngModel)]="solicitante.fax"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_propiet">Email</label>
                    <div class="col-md-6">
                        <input id="email_propiet" name="email_propiet" type="email" placeholder="mail@ejemplo.com"
                            [(ngModel)]="solicitante.mail" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Salir</button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog 2-->

    <ng-template #openModalNODATA>
        <h2 mat-dialog-title>Ingrese datos</h2>
        <mat-dialog-content>
            No ingreso ningun dato del solicitante.
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Aceptar</button>
        </mat-dialog-actions>
    </ng-template>

</div>